import { http } from '@/plugins/axios';

const endPoint = '/Requests';

const getVehicleMarks = () => {
  return http.get(`${endPoint}/VehicleMarks`);
};

export default {
  getVehicleMarks,
};
